import { createFileRoute } from "@tanstack/react-router";
import { fetchSettings } from "@/lib/api";

export const Route = createFileRoute("/disclaimer")({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData({
      queryKey: ["settings"],
      queryFn: fetchSettings,
    });
  },
  head: ({ loaderData }) => {
    const settings = loaderData as any;
    const siteName = settings?.site_name || "Lihar Aksara";
    const canonicalUrl = "https://liharaksara.web.id/disclaimer";
    return {
      meta: [
        { title: `Disclaimer — ${siteName}` },
        { name: "description", content: `Pernyataan Penyangkalan (Disclaimer) ${siteName}.` },
        { property: "og:title", content: `Disclaimer — ${siteName}` },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: DisclaimerPage,
});

function DisclaimerPage() {
  return (
    <div className="container-prose py-16 md:py-24">
      <h1 className="font-serif text-4xl md:text-5xl font-medium mb-8">Disclaimer</h1>
      <div className="prose prose-slate max-w-none font-serif text-lg leading-relaxed text-slate-700 dark:text-slate-300">
        <h2><strong>Disclaimer</strong></h2>
        <p>Seluruh informasi yang tersedia di <a href="https://liharaksara.web.id">Lihar Aksara</a> disediakan untuk tujuan informasi, edukasi, dan hiburan.</p>
        
        <h3><strong>Artikel dan Tutorial</strong></h3>
        <p>Artikel tutorial, panduan teknis, Linux, server, maupun konfigurasi sistem dibuat berdasarkan pengalaman dan pengujian pribadi.</p>
        <p>Pengguna memahami bahwa seluruh tindakan yang dilakukan berdasarkan informasi di website ini menjadi tanggung jawab pribadi masing-masing. Kami tidak bertanggung jawab atas kegagalan teknis, kerusakan perangkat, atau kehilangan data yang mungkin terjadi.</p>

        <h3><strong>Novel dan Karya Fiksi</strong></h3>
        <p>Isi dalam karya fiksi (novel/cerita pendek) sepenuhnya merupakan hasil imajinasi penulis. Pandangan atau perilaku tokoh dalam cerita tidak mewakili pandangan pengelola website di dunia nyata.</p>

        <h3><strong>Akurasi Informasi</strong></h3>
        <p>Meskipun kami berusaha menyajikan konten yang akurat, informasi dapat berubah seiring waktu. Kami tidak memberikan jaminan bahwa seluruh informasi selalu mutakhir atau tanpa kesalahan.</p>

        <h3><strong>Komentar dan Opini</strong></h3>
        <p>Komentar yang ditulis oleh pengunjung merupakan tanggung jawab penulis komentar tersebut. Opini dalam kolom komentar tidak mencerminkan opini resmi dari pengelola website.</p>

        <h3><strong>Tautan Pihak Ketiga</strong></h3>
        <p>Website ini mungkin mencantumkan tautan ke situs lain. Kami tidak memiliki kendali atas isi situs tersebut dan tidak bertanggung jawab atas materi yang dipublikasikan di sana.</p>
      </div>
    </div>
  );
}
